import { useEffect, useMemo, useState } from 'react';
import { CollectorType } from 'graphql/types';
import { useFeatureFlag } from 'modules/common/hooks';
import { SettingId } from '../Setting';
import { useIsScreentimeEnabledForMe } from './useIsScreentimeEnabledForMe';

export const useDisconnectDisabled = ({
  collectorId,
  collectorType
}: {
  collectorId?: string;
  collectorType?: CollectorType;
}): {
  isDisconnectDisabled: boolean;
} => {
  const isScreentimeEnabled: boolean = useFeatureFlag('isScreentimeEnabled');
  const [isDisconnectDisabled, setIsDisconnectDisabled] = useState<boolean>(
    false
  );
  const { isScreentimeEnabledForMe, loading } = useIsScreentimeEnabledForMe({
    input: {
      collectorId: collectorId ?? '',
      id: SettingId.EnableScreentime
    },
    skip:
      !isScreentimeEnabled ||
      !collectorId ||
      collectorType !== CollectorType.Desktop
  });

  useEffect(() => {
    if (loading) setIsDisconnectDisabled(true);
    else {
      setIsDisconnectDisabled(isScreentimeEnabled && isScreentimeEnabledForMe);
    }
  }, [loading, isScreentimeEnabledForMe, isScreentimeEnabled]);
  return useMemo(
    () => ({
      isDisconnectDisabled
    }),
    [isDisconnectDisabled]
  );
};
